export const Products = (props) => {
  return (
    <div id='products' className='text-center'>
      <div className='container'>
        <div className='col-md-10 col-md-offset-1 section-title'>
          <h2>Products</h2>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-xs-6 col-md-4'>
                  {' '}
                  <a href={d.href} className='page-scroll'><img src={d.img} alt='...' className='img'/></a>
                  <a href={d.href} className='page-scroll'><h3>{d.title}</h3></a>
                  <p>{d.text}</p>
                </div>
              ))
            : 'Loading...'}
        </div>
      </div>
    </div>
  )
}
